/** The board's Saved filter, as the URL and the API both spell it. Shared by
 *  the checkbox, the param whitelist, the store's tracked keys and the toast
 *  that ticks it — a second spelling would be a silent no-op. */
export const SAVED_PARAM = 'saved';
